import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=6534098e&scoped=true"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonGroup.vue?vue&type=style&index=0&id=6534098e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534098e",
  null
  
)

export default component.exports